<template>
  <div class="links">
    <div class="head">
      <span class="head-title">{{ isEdit ? 'Edit link' : 'Create link' }}</span>
      <div class="visit" v-if="isEdit" @click="toVisit">
        <span class="visit-text">Visit link</span>
        <i class="iconfont icona-lujing10633"></i>
      </div>
    </div>
    <p class="subtitle">Link text</p>
    <div class="put" :class="{ active: activeText }">
      <el-input
        type="text"
        resize="none"
        autosize
        v-model="text"
        @focus="activeText = true"
        @blur="activeText = false"
      >
      </el-input>
    </div>
    <p class="subtitle">URL</p>
    <div class="put" :class="{ active: activeUrl }">
      <el-input
        type="text"
        resize="none"
        autosize
        v-model="url"
        @focus="activeUrl = true"
        @blur="activeUrl = false"
      >
      </el-input>
    </div>
    <div class="check">
      <md-checkbox v-model="openNew" class="md-primary">Open in new tab </md-checkbox>
    </div>
    <div class="foot">
      <div class="sureBtn" :class="{ disBtn: !text || !url }" @click.stop="apply">Apply</div>
      <div class="cancelBtn" @click="cancel">Cancel</div>
      <p class="remove" v-if="isEdit" @click="remove">Remove link</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: '',
      url: '',
      openNew: true,
      activeText: false,
      activeUrl: false,
      defaultOpen: true
    }
  },
  props: ['isEdit'],
  methods: {
    apply() {
      if (!this.text || !this.url) {
        return
      }
      this.$emit('editLink', this.text, this.url, this.openNew, false, this.defaultOpen)
    },
    setData(text, url, open) {
      this.text = text
      this.url = url
      this.openNew = open
      this.defaultOpen = open
    },
    cancel() {
      this.$emit('editLink')
    },
    remove() {
      this.$emit('editLink', this.text, this.url, this.openNew, true, this.defaultOpen)
    },
    toVisit() {
      window.open(this.url, '_blank')
    }
  }
}
</script>

<style scoped lang="less">
.links {
  width: 330px;
  height: 308px;
  position: absolute;
  padding: 24px;
  z-index: 555;
  background-color: #fff;
  border: 1px solid #cbd6e2;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  .foot {
    align-items: center;
    display: flex;
    margin-top: 16px;
    .remove {
      font-size: 14px;
      color: #0091ae;
      font-family: OpenSans-Bold;
      margin-left: 12px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .sureBtn {
      border-radius: 2px;
      background-color: #425b76;
      color: #ffffff;
      margin-right: 13px;
      width: 48px;
      height: 28px;
      display: flex;
      align-items: center;
      font-size: 12px;
      justify-content: center;
      &:hover {
        background-color: #516f90;
      }
    }
    .disBtn {
      background-color: #eaf0f6;
      color: #b0c1d4;
      &:hover {
        background-color: #eaf0f6;
      }
    }
    .cancelBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      width: 62px;
      font-size: 12px;
      border-radius: 2px;
      color: #506e91;
      background-color: #eaf0f6;
      border: 1px solid #cbd6e2;
      &:hover {
        background-color: #f5f8fa;
      }
    }
  }
  .head {
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    &-title {
      font-size: 16px;
      font-family: OpenSans-Bold1;
      color: #33475b;
    }
    .visit {
      display: flex;
      flex-direction: row;
      align-items: center;
      &-text {
        font-size: 14px;
        font-family: OpenSans-Bold1;
        color: #0091ae;
        &:hover {
          text-decoration: underline;
        }
      }
      .iconfont {
        color: #7c98b6;
        font-size: 16px;
        margin-left: 4px;
      }
    }
  }
  .subtitle {
    font-size: 14px;
    font-family: OpenSans-Bold;
    color: #33475b;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .put {
    width: 100%;
    height: 40px;
    border-radius: 2px;
    background-color: #f5f8fa;
    border: 1px solid #cbd6e2;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    margin-bottom: 16px;

    &.textarea {
      height: unset;
      min-height: 40px;
    }

    .close-datepicker {
      margin: 0;
      padding: 0 8px;
      min-height: unset;

      /deep/ input {
        font-family: OpenSans;
        font-size: 16px;
        color: #33475b;
        -webkit-text-fill-color: #33475b;
      }

      &::after,
      &::before {
        height: 0;
      }
    }

    /deep/ .el-input {
      background-color: #f5f8fa;
      height: 100%;
      display: flex;
      align-items: center;

      .el-textarea__inner {
        border: none;
        padding: 0 8px;
        font-family: OpenSans;
        font-size: 16px;
        color: #33475b;
        background-color: #f5f8fa;
      }

      .el-input__inner {
        border: none;
        padding: 0 8px;
        font-family: OpenSans;
        font-size: 16px;
        color: #33475b;
        background-color: #f5f8fa;
        height: auto;
        line-height: unset;
      }
    }
    &.active {
      border: 2px solid #00d0e4;
    }
  }
  .check {
    display: flex;
    align-items: center;
    height: 20px;
  }
}
</style>

<style lang="less">
.md-checkbox.md-theme-default.md-checked.md-primary .md-checkbox-container {
  background-color: #ffffff !important;
  border-color: #00a4bd !important;
  &:hover {
    background-color: #eaf0f6 !important;
  }
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: #00a4bd !important;
}
.md-checkbox.md-theme-default.md-disabled.md-primary .md-checkbox-container {
  background-color: #eaf0f6 !important;
  border-color: #cbd6e2 !important;
}
.md-checkbox.md-theme-default.md-checked.md-disabled .md-checkbox-container:after {
  border-color: #cbd6e2 !important;
}
.md-checkbox.md-theme-default.md-disabled.md-primary .md-checkbox-label {
  color: #99acc2;
}
</style>
